module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1191"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1191"
    },
    "bundlingPackage": "feedback-public-submission-ui",
    "bundlingPackageVersion": "static-1.30536",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};